var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _StreamCompressor_algorithm;
import './page';
import library from './library';
import * as fflate from 'fflate';
import brotliPromise from 'brotli-wasm';
const brotli = await brotliPromise;
import * as PPMd from "./compressor";
import { Game } from './game';
import { packGame } from './pack';
import makeAirHockey from './games/airHockey';
const lzma = require("lzma/src/lzma_worker.js").LZMA_WORKER;
const LUA_KEYWORDS = `andbreakdoelseelseifendfalseforfunctionifinlocalnilnotorrepeatreturnthentrueuntilwhile`;
function basicGameToData(game) {
    return new TextEncoder().encode(JSON.stringify(game));
}
function basicGameFromData(data) {
    if (data === null)
        return new Game();
    const string = new TextDecoder().decode(data);
    if (string.length === 0)
        return new Game();
    const parsed = JSON.parse(string);
    return new Game(parsed.script, parsed.tileMap);
}
class StreamCompressor {
    constructor(algorithm) {
        _StreamCompressor_algorithm.set(this, void 0);
        __classPrivateFieldSet(this, _StreamCompressor_algorithm, algorithm, "f");
    }
    async compress(data) {
        const stream = new Blob([data]).stream();
        const compressedStream = stream.pipeThrough(new CompressionStream(__classPrivateFieldGet(this, _StreamCompressor_algorithm, "f")));
        return await new Response(compressedStream).bytes();
    }
    async decompress(data) {
        const stream = new Blob([data]).stream();
        const decompressedStream = stream.pipeThrough(new DecompressionStream(__classPrivateFieldGet(this, _StreamCompressor_algorithm, "f")));
        return await new Response(decompressedStream).bytes();
    }
    toString() {
        return "web " + __classPrivateFieldGet(this, _StreamCompressor_algorithm, "f");
    }
}
_StreamCompressor_algorithm = new WeakMap();
const compressors = [
    new StreamCompressor("deflate-raw"),
    new StreamCompressor("gzip"),
    //new StreamCompressor("deflate"),
];
const fflateOpts = {
    level: 9,
    mem: 8
};
const fflateOptsDict = {
    level: 9,
    mem: 8,
    dictionary: new TextEncoder().encode(LUA_KEYWORDS)
};
function benchmarkGames(target, games, name, compressor) {
    const row = target.insertRow();
    row.insertCell().innerText = name;
    let total = 0;
    for (const data of games) {
        const length = packGame(data, compressor).length;
        row.insertCell().innerText = length.toString();
        total += length;
    }
    row.insertCell().innerText = total.toString();
}
const benchmarkButton = document.getElementById('benchmark-button');
const benchmarkTable = document.getElementById('benchmark-table');
benchmarkButton.onclick = async function () {
    // Add column header
    let firstRow = benchmarkTable.insertRow();
    firstRow.insertCell().innerText = "";
    for (const entry of library) {
        firstRow.insertCell().innerText = entry.metadata.title;
    }
    firstRow.insertCell().innerText = "Total";
    benchmarkGames(benchmarkTable, library, "raw", (data) => data);
    benchmarkGames(benchmarkTable, library, "gzip", (data) => fflate.gzipSync(data, fflateOpts));
    benchmarkGames(benchmarkTable, library, "zlib", (data) => fflate.zlibSync(data, fflateOpts));
    benchmarkGames(benchmarkTable, library, "lzma", (data) => lzma.compress(data, 9));
    benchmarkGames(benchmarkTable, library, "brotli", (data) => brotli.compress(data, { quality: 11 }));
    benchmarkGames(benchmarkTable, library, "ppmd", (data) => PPMd.compress(data));
    // Remove button
    benchmarkButton.remove();
};
const ppmdButton = document.getElementById('ppmd-button');
const ppmdParagraph = document.getElementById('ppmd-paragraph');
function testPPMd(data) {
    let dataOut = PPMd.decompress(PPMd.compress(data));
    if (data.byteLength !== dataOut.byteLength) {
        return false;
    }
    for (let i = 0; i < data.byteLength; i++) {
        if (data[i] != dataOut[i]) {
            return false;
        }
    }
    return true;
}
ppmdButton.onclick = async function () {
    const zeroBytes = testPPMd(new Uint8Array(10240));
    const airHockey = testPPMd(basicGameToData(makeAirHockey()));
    const randomBytesArray = new Uint8Array(10240);
    for (let i = 0; i < randomBytesArray.byteLength; i++) {
        randomBytesArray[i] = Math.floor(Math.random() * 256);
    }
    const randomBytes = testPPMd(randomBytesArray);
    ppmdParagraph.innerHTML = `Zero bytes: ${zeroBytes} <br> Air Hockey: ${airHockey} <br> Random Bytes: ${randomBytes}`;
    ppmdButton.remove();
};
